import styled from '@emotion/styled'
import { tokens } from '@news-mono/design-tokens'
import { WebLink } from '@news-mono/web-common'
import { SubHeadingElements } from '../../typography/Subhead/Subhead'
import { colors, fonts } from '../../__styling'
import { breakpoint } from '../../__styling/style-functions/breakpoint'
import { calcRem } from '../../__styling/style-functions/calc-rem'

export interface StyledHeadingProps {
    textCenter?: boolean
    hasBackground?: boolean
    borderWidth?: number
    specificFontSize?: number
}

export const StyledHeading = (hSize: SubHeadingElements) =>
    styled(hSize)<StyledHeadingProps>(
        ({
            theme,
            hasBackground,
            textCenter,
            borderWidth,
            specificFontSize,
        }) => [
            {
                fontSize: specificFontSize
                    ? calcRem(specificFontSize)
                    : calcRem(32),
                fontFamily: fonts.sevennews.headingAlternative,
                fontWeight: 400,
                marginBottom: calcRem(16),
                marginTop: 0,
                color: tokens.sevennews.colors.palette.bauhausBlack,
                borderBottom: `${calcRem(borderWidth || 4)} solid ${
                    tokens.sevennews.colors.palette.bauhausBlack
                }`,
                borderLeftWidth: 0,
                borderRightWidth: 0,
                borderTopWidth: 0,
                display: 'flex',
                justifyContent: textCenter ? 'center' : 'space-between',
                textAlign: textCenter ? 'center' : 'initial',
                alignItems: 'center',
                [breakpoint('sm')]: {
                    borderBottomWidth: calcRem(borderWidth || 6),
                    marginBottom: calcRem(16),
                },
                [breakpoint('md')]: {
                    borderBottomWidth: calcRem(borderWidth || 8),
                },
            },
            hasBackground === true && {
                fontSize: calcRem(32),
                paddingTop: calcRem(15),
                color: colors.white,
                borderImage:
                    'linear-gradient(90deg,#fff -0.04%, rgba(255,255,255,0) 99.96%) 30',
                [breakpoint('sm')]: {
                    fontSize: calcRem(32),
                },
                [breakpoint('md')]: {
                    fontSize: calcRem(32),
                },
            },
        ],
    )

export const StyledWebLink = styled(WebLink)(() => ({
    textDecoration: 'none',
    color: 'inherit',
}))

export const StyledSeeAllLink = styled(StyledWebLink)(() => ({
    fontSize: calcRem(12),
    [breakpoint('md')]: {
        fontSize: calcRem(16),
    },
}))
